import { createFileRoute } from '@tanstack/react-router';

import { SourcingTemplateDuplicatePage } from '@/areas/sourcing-scenarios/SourcingTemplates/SourcingTemplateDuplicatePage';
import { canManageSourcingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/duplicate')({
    staticData: { access: { permissions: canManageSourcingTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <SourcingTemplateDuplicatePage {...pathParams} />;
}
